import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { FormatService } from '@/app/common/format/format.service';
import { VideoResponseDto } from '@/app/common/general-types/videos.dto';
import { SuperSocialService } from '@/app/services/super-social/super-social.service';
import { SelectedSocialPostEvent } from '../application-actions/application-actions.types';

interface TikTokSelectionPost {
  id: string;
  title?: string;
  cover_image_url?: string;
  share_url?: string;
  create_time?: number;
}

@Component({
  selector: 'ins-creator-select-post-tiktok',
  templateUrl: './select-post-tiktok.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class CreatorSelectPostTiktok implements OnInit {
  tiktokAccountId = input.required<string>();
  appVid = input.required<VideoResponseDto>();

  selectedPost = output<SelectedSocialPostEvent>();

  readonly latestPosts = signal<TikTokSelectionPost[] | undefined>(undefined);
  readonly loadingState = signal<'idle' | 'loading' | 'loaded' | 'error'>('idle');

  readonly formatService = inject(FormatService);
  private destroyRef = inject(DestroyRef);
  private superSocialService = inject(SuperSocialService);

  ngOnInit(): void {
    this.loadingState.set('loading');
    this.superSocialService
      .getPostsForSelectionTikTok(this.tiktokAccountId())
      .pipe(
        catchError(() => {
          this.loadingState.set('error');
          return of({ videos: [] as TikTokSelectionPost[] });
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((response) => {
        this.latestPosts.set(response.videos ?? []);
        this.loadingState.set('loaded');
      });
  }

  selectPost(post: TikTokSelectionPost): void {
    this.selectedPost.emit({ post, appVid: this.appVid() });
  }

  postTimeLabel(post: TikTokSelectionPost): string {
    if (!post.create_time) {
      return '';
    }
    return this.formatService.getTimeSinceUpdated(new Date(post.create_time * 1000));
  }
}
